(() => {
  if(!document.getElementById('o-app'))return;
  const key='ch_demo_cart_v1';
  oBuild();
  try{
    const saved=JSON.parse(sessionStorage.getItem(key)||'null');
    if(saved && saved.version===1 && saved.cart && typeof saved.cart==='object'){
      for(const [id,quantity] of Object.entries(saved.cart))if(O_BY[id] && Number.isFinite(quantity) && quantity>0 && quantity<1000000){O_CART[id]=quantity;if(saved.cert?.[id]===true)O_CERT[id]=true;}
    }
  }catch{}
  const originalTotals=oTotals;
  oTotals=function(){const total=originalTotals();try{sessionStorage.setItem(key,JSON.stringify({version:1,cart:O_CART,cert:O_CERT}));}catch{}return total;};
  try{if(sessionStorage.getItem('ldf_ok')==='1')oOpen();else if(O_CAT){oRender();oTotals();}}catch{}
})();
